import { useEffect } from "react";
import { commonMetadata } from "@/lib/constants/metadata";

interface UsePageTitleOptions {
  separator?: string;
  includeAppName?: boolean;
}

export const usePageTitle = (
  pageTitle?: string | null,
  { separator = " - ", includeAppName = true }: UsePageTitleOptions = {},
) => {
  useEffect(() => {
    const appName = commonMetadata.title;

    if (typeof document === "undefined") return;

    const previousTitle = document.title;
    const normalizedPageTitle = pageTitle?.trim();

    document.title = normalizedPageTitle
      ? includeAppName
        ? `${normalizedPageTitle}${separator}${appName}`
        : normalizedPageTitle
      : appName;

    return () => {
      document.title = previousTitle;
    };
  }, [includeAppName, pageTitle, separator]);
};
